import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Box
} from '@mui/material';
import { Close } from '@mui/icons-material';
import CierreCaja from './CierreCaja';

/**
 * Modal wrapper para el componente CierreCaja
 */
const CierreCajaModal = ({ open, onClose }) => {
    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="lg" 
            fullWidth
            PaperProps={{
                sx: { height: '90vh' }
            }}
        >
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    🔒 Cerrar Caja - Arqueo Final
                    <IconButton onClick={onClose} size="small">
                        <Close />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
                <Box sx={{ height: '100%', overflow: 'auto', p: 2 }}>
                    <CierreCaja />
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default CierreCajaModal;
